import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    teams: [],
    game: {},
  },
  mutations: {
    setTeams(state, payload) {
      state.teams = payload;
    },
    setGame(state, payload) {
      state.game = payload;
    },
    addTeam(state, payload) {
      state.teams.push(payload);
    },
    updateTeam(state, payload) {
      let foundIndex = -1;
      state.teams.forEach((team, index) => {
        if (parseInt(team.id, 10) === parseInt(payload.id, 10)) {
          foundIndex = index;
        }
      });

      if (foundIndex >= 0) {
        console.log(foundIndex);
        state.teams.splice(foundIndex, 1, payload);
      }
    },
    deleteTeam(state, payload) {
      let foundIndex = -1;
      state.teams.forEach((team, index) => {
        if (parseInt(team.id, 10) === parseInt(payload.id, 10)) {
          foundIndex = index;
        }
      });

      if (foundIndex >= 0) {
        console.log(foundIndex);
        state.teams.splice(foundIndex, 1);
      }
    },
  },
  actions: {
    SOCKET_updated_team(context, message) {
      console.log(message);
      let livegameId = -1;
      if (!Number.isNaN(parseInt(message.livegame, 10))) {
        livegameId = parseInt(message.livegame, 10);
      } else if (message.livegame && message.livegame.id) {
        livegameId = message.livegame.id;
      }
      console.log(Number.isNaN(parseInt(message.livegame, 10)), livegameId);

      if (livegameId === parseInt(context.state.game.id, 10)) {
        let foundIndex = -1;
        context.state.teams.forEach((team, index) => {
          if (parseInt(team.id, 10) === parseInt(message.id, 10)) {
            foundIndex = index;
          }
        });

        if (foundIndex >= 0) {
          context.commit('updateTeam', message);
        } else {
          context.commit('addTeam', message);
        }
      }
    },
    SOCKET_deleted_team(context, message) {
      context.commit('deleteTeam', message);
    },
    SOCKET_updated_game(context) {
      context.dispatch('getGame');
    },
    getTeams(context) {
      axios.get('/liveteams')
        .then((response) => {
          context.commit('setTeams', response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGame(context) {
      axios.get('/livegames/active')
        .then((response) => {
          if (Object.keys(response.data).length > 0) {
            context.commit('setGame', response.data);
            context.commit('setTeams', response.data ? response.data.liveteams : []);
          } else {
            context.commit('setGame', null);
            context.commit('setTeams', []);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
});
